<script setup>
    // Wird als Kunden löschen in /start und als Antrag löschen in Kundenanträge benutzt. Muss also wiederverwendbar sein.

    import axios from 'axios';
    import Swal from 'sweetalert2';

    const props = defineProps(['fetchUrl', 'thingToDelete', 'redirectUrl']);

    // den Antrag, die Kund:in.
    const article = props.thingToDelete == "Kund:in" ? "die" : "den";

    // hard-deletes Antrag/customer in case some bad hiccup happened. Don't use lightly!
    function deleteThing() {
        Swal.fire({
            title: "Sind Sie sicher?",
            text: "Sind Sie sicher, dass Sie " + article + " " + props.thingToDelete + " löschen wollen? Bitte nutzen Sie diese Funktion nur, wenn sie alternativlos ist!",
            icon: "warning",
            confirmButtonText: "Löschen",
            confirmButtonColor: "#e64942",
            showCancelButton: true,
            cancelButtonText: "Abbrechen",
            focusCancel: true,
            reverseButtons: true,
        }).then((result) => {
            // IT HARD-DELETES USERS, NOT SOFT-DELETES THEM!!
            if (result.isConfirmed) {
                axios.delete(props.fetchUrl)
                .then((data) => {
                    if (data.status === 200) {
                        Swal.fire({
                            title: "Erfolgreich",
                            text: "Daten wurden gelöscht!",
                            icon: "success",
                        }).then((result) => {
                            if (result.isConfirmed === true) {
                                window.location.reload();
                            }
                        })
                    }
                })
            }
        }).catch((error) => {
            Swal.fire({
                title: "Fehlgeschlagen",
                text: error.response.data.message,
                icon: 'error',
            })
        })
    }

</script>

<template>
    <button class="btn btn-primary" type="button" @click="deleteThing()">
        <i class="fa-solid fa-trash"></i> {{ props.thingToDelete }} löschen
    </button>
</template>
